<!-- Booking Request Sent Modal Starts -->
<div class="modal sent fade" id="request-sent-modal" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="container-fluid text-center">
                    <div class="d-flex flex-column py-2">
                        <div class="correct-icon-section text-center mt-3">
                            <i class="fas fa-check correct-icon"></i>
                        </div>
                        <span class="header mt-3 text-center">Appointment request sent</span>
                        <span class="my-3 text-center">Loerm incididunt ut labore et dolore magna aliqua. Ut enim ad
                            mini abore et dolore magna aliqua. Ut enim ad mini</span>
                    </div>
                    <button class="btn btn-sent btn-theme mb-4" data-dismiss="modal">Ok</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Booking Request Sent Modal Ends -->

<!-- Add Appointment Modal Statrs -->
<div class="modal add-appointment fade" id="add-appointment" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="d-flex flex-column px-3">
                    <div class="d-flex flex-row justify-content-between mt-3 mb-1">
                        <span class="modal-title">Add appointment</span>
                        <i class="fas fa-times modal-close" data-dismiss="modal"></i>
                    </div>
                    <span class="mt-2 mb-4 modal-text">{{appointmentDate | date:'EEE dd MMMM, yyyy'}}</span>
                    <span class="title mb-2">Select mom</span>
                    <mat-form-field class="w-100 mb-3">
                        <mat-select [(ngModel)]="selectedMum" name="select mom" id="select-mom"
                            (selectionChange)="selectMum($event.value)">
                            <mat-option *ngFor="let mum of signedUpMum" [value]="mum">
                                <img class="dropdown-profile-img" *ngIf="!mum?.profileImage"
                                    src="../../../../../../assets/Images/pro-pic.png">
                                <img class="dropdown-profile-img" *ngIf="mum?.profileImage"
                                    [src]="mum?.profileImage">{{mum?.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="title mb-2">Descripton</span>
                    <input type="text" class="form-control form-control-sm mb-3" [(ngModel)]="description"
                        placeholder="Description">
                    <div class="d-flex flex-row justify-content-end my-3">
                        <button class="btn btn-cancel mr-2" data-dismiss="modal" (click)="clearData()">Cancel</button>
                        <button class="btn btn-theme" [disabled]="!selectedMum || !description.length"
                            (click)="createAppointment()" data-dismiss="modal">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Add Appointment Modal Ends -->

